import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, provideKeycloak } from 'keycloak-angular';
import { environment } from "../../environments/environment";

const urlPatternEscaped = `^(${environment.api.host_path})(/.*)?$`.replaceAll('/', '\\/');

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`${urlPatternEscaped}`, 'i'),
  bearerPrefix: 'Bearer'
});
export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      url: environment.keycloak.url,
      realm: environment.keycloak.realm,
      clientId: environment.keycloak.clientId
    },
    initOptions: {
      onLoad: 'login-required',
      enableLogging: environment.production ? false : true
    },
    providers: [{
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition]
    }],
  });